export default "__VITE_ASSET__Cxs5hgCL__"